export default __webpack_public_path__ + "static/media/hexapodTop@2x.82c4c7eb.png";